import React from "react";

export const Header: React.FC = () => {
  return (
    <header
      style={{
        padding: "0.5rem 0.9rem 0.1rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }}
    >
      <div className="stack-h stack-h--gap-sm" style={{ alignItems: "center" }}>
        <div
          style={{
            width: 24,
            height: 24,
            borderRadius: 8,
            background:
              "conic-gradient(from 220deg, #22c55e, #22d3ee, #6366f1, #22c55e)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 13,
            fontWeight: 700,
            color: "#020617",
            boxShadow: "0 10px 24px rgba(15, 23, 42, 0.85)"
          }}
        >
          P
        </div>
        <div className="stack-v stack-v--gap-xs">
          <span className="text-sm" style={{ fontWeight: 650 }}>
            PulsePuzzles
          </span>
          <span className="text-xs text-muted">race to solve with your friends</span>
        </div>
      </div>

      <nav aria-label="Primary navigation">
        <div className="pill pill--accent text-xs">multiplayer-ready</div>
      </nav>
    </header>
  );
};


